import { createContext } from 'react';

const ThemeContext = createContext({
    theme: "light",
    setTheme: () => {}
});
ThemeContext.displayName = 'ThemeContext';

export default ThemeContext
